import { GestureDetail, createGesture } from '@ionic/core';
import { ToastController } from '@ionic/angular';
import { successNotification } from '../../constants';

const longPressGesture = (el: HTMLElement, callback: VoidFunction) => {
  const TIMEOUT = 500;
  let timeout: ReturnType<typeof setTimeout> | undefined;

  const clearGestureTimeout = () => {
    if (timeout) {
      clearTimeout(timeout);
      timeout = undefined;
    }
  };

  const onStart = () => {
    clearGestureTimeout();

    timeout = setTimeout(() => {
      callback();
      timeout = undefined;
    }, TIMEOUT);
  };

  const onMove = (detail: GestureDetail) => {
    if (detail.deltaX <= 10 && detail.deltaY <= 10) {
      return;
    }

    clearGestureTimeout();
  };

  const gesture = createGesture({
    el: el,
    threshold: 0,
    onMove: onMove,
    onStart: onStart,
    onEnd: clearGestureTimeout,
    gestureName: 'long-press',
  });

  gesture.enable(true);

  return gesture.destroy;
};

export const copyToClipboard = (value: string): Promise<boolean> => {
  return new Promise((resolve) => {
    if ('clipboard' in navigator) {
      navigator.clipboard
        .writeText(value)
        .then(() => resolve(true))
        .catch(() => resolve(false));
    } else {
      // Используем запасной метод для копирования текста
      const textArea = document.createElement('textarea');
      textArea.value = value;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        const success = document.execCommand('copy');
        resolve(success);
      } catch {
        resolve(false);
      } finally {
        document.body.removeChild(textArea);
      }
    }
  });
};

export const copyOnLongPress = (el: HTMLElement, string: string) => {
  return longPressGesture(el, async () => {
    copyToClipboard(string).then(async (isCopied) => {
      if (isCopied) {
        const toastController = new ToastController();
        const toast = await toastController.create({
          message: 'Текст скопирован',
          duration: 3000,
          position: 'bottom',
          icon: successNotification,
          color: 'dark',
          mode: 'ios',
          cssClass: 'custom-ion-toast',
        });
        toast.present();
      }
    });
  });
};
